import { Divider, Flex, Skeleton, SkeletonCircle } from '@chakra-ui/react';
import { Fragment } from 'react';

const ContributorLoadingCell = ({ rowHeight }: { rowHeight?: string }) => {
  return (
    <>
      <Flex p={4} bg="white" minH={rowHeight || '110px'}>
        <SkeletonCircle size="6" mr={3} />
        <Flex direction="column" gap={1} flex={1}>
          <Skeleton height="20px" width="120px" mb={1} />
          <Skeleton height="16px" width="80px" mb={1} />
          <Skeleton height="16px" width="180px" />
        </Flex>
        <SkeletonCircle size="4" mt={'auto'} />
      </Flex>
      <Divider />
    </>
  );
};

export default ContributorLoadingCell;
